module.exports = "../../../../platform/assets/pageMainIcon/business_baobiaochaxunlei3.svg";